import { connect } from 'react-redux'
import LanguageProvider from './LanguageProvider'

export default connect((stateProps) => ({
  ...stateProps
}))(LanguageProvider)
